<ng-template #selectedItemTemplate let-item>
    <span class="inline-flex items-center gap-1.5">
        @if (getProductTypeIconClass(item.productType); as iconClass) {
            <i
                [class]="iconClass"
                [pTooltip]="'enums.' + item.productType | translate"
                tooltipPosition="top"
                [showDelay]="500"
                aria-hidden="true"
            ></i>
        }
        <span>
            <span class="font-semibold">{{ item.identifier }}</span>
            <ng-container *ngIf="item.description"> - {{ item.description }}</ng-container>
        </span>
    </span>
</ng-template>
<ng-template #itemTemplate let-item>
    <div class="flex items-center gap-1.5">
        @if (getProductTypeIconClass(item.productType); as iconClass) {
            <i
                [class]="iconClass"
                [pTooltip]="'enums.' + item.productType | translate"
                tooltipPosition="top"
                [showDelay]="500"
                aria-hidden="true"
            ></i>
        }
        <div class="flex min-w-0 flex-col">
            <div>
                <span class="font-semibold">{{ item.identifier }}</span>
                @if (item.description) {
                    <span [pTooltip]="item.description" tooltipPosition="top" [showDelay]="500">
                        - {{ item.description }}</span
                    >
                }
            </div>
            @if (item.addition) {
                <span
                    [pTooltip]="item.addition"
                    [showDelay]="500"
                    tooltipPosition="left"
                    class="text-surface-600 text-sm"
                    >{{ item.addition }}</span
                >
            }
        </div>
    </div>
</ng-template>

<ng-template #postSelectTemplate let-item>
    <div class="flex items-center">
        <p-button
            *ngIf="
                ((props.showWarehouseStockButton || showWarehouseStockButton) &&
                    formControl?.value?.productType === 'STORE') ||
                formControl?.value?.productType === 'SIMPLEPRODUCTION'
            "
            styleClass="grow-0"
            (onClick)="productStorageVisible = true"
            text="true"
            pTooltip="{{ 'product.showWarehouseStockButton' | translate }}"
            ><i class="fa-solid fa-warehouse"></i>
        </p-button>
    </div>
</ng-template>

<p-drawer
    [visible]="productStorageVisible"
    (visibleChange)="productStorageVisible = $event"
    position="right"
    styleClass="sidebar-style"
>
    <app-product-stock-chart-diagram
        [productId]="formControl?.value?.id"
        [stackLayout]="true"
        *ngIf="productStorageVisible && formControl?.value?.id"
    ></app-product-stock-chart-diagram>
</p-drawer>
